import "./togle_theme.css"
$(document).ready(function () {
    function dark(){
        $(".menu_sub_dark").addClass("ds-none")
        $(".menu_sub_light").removeClass("ds-none")
        const theme="dark";
        $("html").addClass(theme)
        jqueryts.storage.local.put("theme", theme)
        document.cookie = "theme=dark; path=/";
    }
    function light(){
        $(".menu_sub_light").addClass("ds-none")
        $(".menu_sub_dark").removeClass("ds-none")
        $("html").removeClass("dark")
        const theme="light";
        jqueryts.storage.local.put("theme", theme)
        document.cookie = "theme=light; path=/";
    }
    $(".menu_sub_dark").on( "click", function() {
        dark();
    })
    $(".menu_sub_light").on( "click", function() {
        light();
    })
    // let theme = $.cookie('theme');

    if (jqueryts.storage.cookie.getRaw("theme")==="dark"){
        $(".menu_sub_dark").addClass("ds-none")
        $(".menu_sub_light").removeClass("ds-none")
    } else {
        $(".menu_sub_light").addClass("ds-none")
        $(".menu_sub_dark").removeClass("ds-none")
    }
})